import defaultSettings from '@/settings'

const title = 'IM客服聊天'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
